/* unplugin-vue-components disabled */import { render } from "./studentManagement.vue?vue&type=template&id=3696e9f8&scoped=true"
import script from "./studentManagement.vue?vue&type=script&lang=js"
export * from "./studentManagement.vue?vue&type=script&lang=js"

import "./studentManagement.vue?vue&type=style&index=0&id=3696e9f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3696e9f8"]])

export default __exports__